import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './space.css';
import Card from '../Card/Card';
import { Copy } from 'lucide-react';

const SpaceSnipp = () => {

  const widthSnippetRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const wCopySnippet = () => {
    if (widthSnippetRef.current) {
      const range = document.createRange();
      range.selectNode(widthSnippetRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  const hSnippetRef = useRef(null);
  const [hShowScanning, hSetShowScanning] = useState(false);

  const hCopySnippet = () => {
    if (hSnippetRef.current) {
      const range = document.createRange();
      range.selectNode(hSnippetRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      hSetShowScanning(true);
      setTimeout(() => hSetShowScanning(false), 1000);
    }
  };
  return (
    <>
      <pre>
        <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={widthSnippetRef}>
            <code>
              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-tiny</span><span class="cln">"</span><span class="cn">&gt;</span>margin: 1.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-norm</span><span class="cln">"</span><span class="cn">&gt;</span>margin: 2rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-top-tiny</span><span class="cln">"</span><span class="cn">&gt;</span>margin-top: 1.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-top-norm</span><span class="cln">"</span><span class="cn">&gt;</span>margin-top: 2rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-top-hefty</span><span class="cln">"</span><span class="cn">&gt;</span>margin-top: 2.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-bottom-tiny</span><span class="cln">"</span><span class="cn">&gt;</span>margin-bottom: 1.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-bottom-norm</span><span class="cln">"</span><span class="cn">&gt;</span>margin-bottom: 2rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-bottom-hefty</span><span class="cln">"</span><span class="cn">&gt;</span>margin-bottom: 2.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-left-tiny</span><span class="cln">"</span><span class="cn">&gt;</span>margin-left: 1.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-left-norm</span><span class="cln">"</span><span class="cn">&gt;</span>margin-left: 2rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-left-hefty</span><span class="cln">"</span><span class="cn">&gt;</span>margin-left: 2.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-right-tiny</span><span class="cln">"</span><span class="cn">&gt;</span>margin-right: 1.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-right-norm</span><span class="cln">"</span><span class="cn">&gt;</span>margin-right: 2rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-space-right-hefty</span><span class="cln">"</span><span class="cn">&gt;</span>margin-right: 2.5rem;<span class="cn">&lt;/div&gt;</span>

            </code>
          </div>
          <button aria-label="Copy Button" onClick={wCopySnippet}>
            <Copy />
          </button>
        </div>
        <div className={`center-container ${hShowScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={hSnippetRef}>
            <code>
              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-tiny</span><span class="cln">"</span><span class="cn">&gt;</span>padding: 1.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-norm</span><span class="cln">"</span><span class="cn">&gt;</span>padding: 2rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-top-tiny</span><span class="cln">"</span><span class="cn">&gt;</span>padding-top: 1.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-top-norm</span><span class="cln">"</span><span class="cn">&gt;</span>padding-top: 2rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-top-hefty</span><span class="cln">"</span><span class="cn">&gt;</span>padding-top: 2.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-bottom-tiny</span><span class="cln">"</span><span class="cn">&gt;</span>padding-bottom: 1.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-bottom-norm</span><span class="cln">"</span><span class="cn">&gt;</span>padding-bottom: 2rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-bottom-hefty</span><span class="cln">"</span><span class="cn">&gt;</span>padding-bottom: 2.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-left-tiny</span><span class="cln">"</span><span class="cn">&gt;</span>padding-left: 1.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-left-norm</span><span class="cln">"</span><span class="cn">&gt;</span>padding-left: 2rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-left-hefty</span><span class="cln">"</span><span class="cn">&gt;</span>padding-left: 2.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-right-tiny</span><span class="cln">"</span><span class="cn">&gt;</span>padding-right: 1.5rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-right-norm</span><span class="cln">"</span><span class="cn">&gt;</span>padding-right: 2rem;<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-gap-right-hefty</span><span class="cln">"</span><span class="cn">&gt;</span>padding-right: 2.5rem;<span class="cn">&lt;/div&gt;</span>

            </code>
          </div>
          <button aria-label="Copy Button" onClick={hCopySnippet}>
            <Copy />
          </button>
        </div>
      </pre>
    </>
  );
}

const Space = () => {
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Card
        CardTitle='Margin & Padding'
        CardBody={<SpaceSnipp />}
      />
    </motion.div>
  );
}

Space.propTypes = {};

export default Space;
